import state from "@/store/modules/account/state";
import actions from "@/store/modules/account/actions";
import getters from "@/store/modules/account/getters";
import mutations from "@/store/modules/account/mutations";

import dealers from "@/store/modules/account/dealers/index";
import orders from "@/store/modules/account/orders/index";
import newOrder from "@/store/modules/account/new-order/index";
import warehouse from "@/store/modules/account/warehouse/index";
import accesses from "@/store/modules/account/accesses/index";
import documents from "@/store/modules/account/documents/index";
import reclamations from "@/store/modules/account/reclamations/index";

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    orders,
    newOrder,
    dealers,
    warehouse,
    accesses,
    documents,
    reclamations,
  },
};
